import React from 'react';
import { Phone } from 'lucide-react';
import { LiveOrderTicker } from './LiveOrderTicker';
const PHONE_NUMBER = '(206) 619-3742';
export function AnnouncementBar() {
  return <div className="relative z-[60] border-b border-[#00311c]/60 bg-[#2E2121] px-4 py-1.5 text-white" data-id="element-157" data-mp="ju3kwt5wray3">
      <div className="mx-auto flex max-w-7xl items-center gap-2 sm:gap-4" data-id="element-158" data-mp="ev0jdip4zmuv">
        <LiveOrderTicker data-id="element-159" data-mp="eswdiv7ogdry" />
        <a href="tel:206-619-3742" aria-label={`Call ${PHONE_NUMBER}`} className="inline-flex h-7 shrink-0 items-center justify-center border-l border-white/20 px-3 text-xs font-semibold tracking-tight text-[#00b774] transition-colors hover:text-white md:justify-start md:gap-1.5 md:pl-4 md:pr-0 md:text-sm" data-id="element-160" data-mp="9vnvqvqfybr8">
          <Phone className="h-4 w-4 text-[#00b774]" data-id="element-161" data-mp="3s225eihofzjt" />
          <span className="hidden whitespace-nowrap md:inline" data-id="element-162" data-mp="3s3n1icjn3qjs">{PHONE_NUMBER}</span>
        </a>
      </div>
    </div>;
}